import styled from '@emotion/styled';

export const CalendarLabels = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #dfdfdf;
`;
